// extracted by mini-css-extract-plugin
export var copy = "image-block-module--copy--f697f";
export var description = "image-block-module--description--81e65";
export var fill = "image-block-module--fill--a2b8d";
export var image = "image-block-module--image--cdead";
export var root = "image-block-module--root--51787";
export var source = "image-block-module--source--6ad3b";